export default __webpack_public_path__ + "static/media/Stars.693afbdc.svg";